var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Container, FormGroup, Form, Card, CardFooter, CardBody, Row, Col } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Signals from '../../../signals/Signals';
import { ApplicationContext } from '../../../ApplicationContext';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import FormField from '../../components/ui/FormField/FormField';
import { FormErrorContext } from '../../../FormErrorContext';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import ArchiveAssetCommand from '../../../commands/assets/ArchiveAssetCommand';
/**
 *
 */
var ArchiveAssetOverlay = /** @class */ (function (_super) {
    __extends(ArchiveAssetOverlay, _super);
    /**
     *
     * @param props
     */
    function ArchiveAssetOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            submitting: false,
            reason: null
        };
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        return _this;
    }
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ArchiveAssetOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    ArchiveAssetOverlay.prototype.render = function () {
        var _a = this.props, className = _a.className, intl = _a.intl, assetModel = _a.assetModel;
        var _b = this.state, errors = _b.errors, reason = _b.reason;
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return React.createElement(Container, { className: 'asset-archive-close-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'asset.archive.close.overlay.title' }, assetModel) }),
                        React.createElement(CardBody, null,
                            React.createElement(Row, null,
                                React.createElement(Col, null,
                                    React.createElement(Row, null,
                                        React.createElement(Col, null,
                                            React.createElement("h3", null,
                                                React.createElement(FormattedMessage, { id: "asset.archive.pay.attention" })),
                                            React.createElement("p", null,
                                                React.createElement(FormattedMessage, { id: "asset.archive.warning.message" })))))),
                            React.createElement("hr", null),
                            React.createElement(Row, null,
                                React.createElement(Col, { sm: 12 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Row, null,
                                            React.createElement(Col, null,
                                                React.createElement("label", { htmlFor: "reason" },
                                                    React.createElement(FormattedMessage, { id: "asset.archive.close.overlay.field.reason" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("textarea", { className: "form-control", id: "reason", name: "reason", required: true }, reason)))))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "asset.archive.close.overlay.submit" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param event
     */
    ArchiveAssetOverlay.prototype.onInputChange = function (event) {
        var newState = {};
        switch (event.target.name) {
            default:
                newState[event.target.name] = event.target.value;
        }
        this.setState(newState);
    };
    /**
     *
     * @param event
     */
    ArchiveAssetOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var assetModel = this.props.assetModel;
        var reason = this.state.reason;
        if (!assetModel) {
            return;
        }
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var intl = this.props.intl;
        var command = new ArchiveAssetCommand();
        command.execute(reason, session.user.organisation, assetModel, assetCollection, intl).then(this.onSuccess);
    };
    /**
     *
     */
    ArchiveAssetOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    /**
     *
     */
    ArchiveAssetOverlay.prototype.onSuccess = function () {
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
        Signals.HideAssetDetail.dispatch();
    };
    /**
     *
     * @param error
     */
    ArchiveAssetOverlay.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    ArchiveAssetOverlay.defaultProps = {
        className: ''
    };
    ArchiveAssetOverlay = __decorate([
        observer
    ], ArchiveAssetOverlay);
    return ArchiveAssetOverlay;
}(React.Component));
ArchiveAssetOverlay.contextType = ApplicationContext;
export default injectIntl(ArchiveAssetOverlay);
